// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-columns-export-modal {
  width: 50vw !important;
  height: 90vh !important;
  overflow-y: auto;
}
.export-modal-title {
  font-size: 21px;
}
.export-container {
  overflow-y: auto;
  border: 1px solid #d3d3d3;
  height: 528px;
  border-radius: 10px;
  opacity: 1;
  top: 167px;
  left: 30px;
  border-width: 1px;
  padding: 17px 15px;
  scrollbar-width: thin;
}

.export-container::-webkit-scrollbar {
  height: 12px;
}

.available-column .ant-checkbox-group-item {
  padding-top: 20px;
  width: 100%;
}
.export-help-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #717171;
  margin-top: 14px;
}
.search-column {
  background: #f0f0f0 !important;
  height: 3vh !important;
  margin-bottom: 1.2rem;
  border: 1px solid #d9d9d9 !important;
}
.set-margin {
  margin-right: 12px;
}
.col-header {
  padding: 5px 0;
  font-weight: bold;
  font-size: 14px;
  font-weight: 500;
}

.col-label {
  padding: 5px 0;
  display: flex;
  align-items: center;
}
.align-right {
  margin-left: auto;
}
.footer-buttons {
  margin-top: 33px;
}

.export-footer-btn {
  height: 35px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  background-color: #d2042d !important;
  color: #fff !important;
}
.export-cancel-btn {
  background: #e0e0e0 !important;
  color: #0a0f0d !important;
  opacity: 1;
  gap: 8px;
}

.export-btn {
  background: #d2042d !important;
  color: #fff !important;
  cursor: pointer;
}

.export-spin {
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .export-selection-container {
    margin-left: 19px;
  }
  .export-selection-container {
    margin-left: 19px;
    overflow: auto;
  }
  .export-header {
    height: 70px;
    font-size: 19px;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
  .export-title {
    margin-left: 12px;
  }
  .reverse-content {
    display: flex;
    flex-direction: column-reverse;
    overflow-y: auto;
  }
  .search-column {
    height: 35px !important;
  }
  .available-cols {
    height: 30vh;
  }
  .export-help-text {
    font-size: 13px;
    color: #686868;
    margin-top: 6px;
    margin-bottom: 16px;
  }
  .export-container {
    background: #fff;
    width: 88vw;
  }
  .selected-cols {
    height: max-content;
    margin-bottom: 2rem;
  }
  .selected-mobile {
    margin-top: 24px;
  }

  .mobile-footer {
    position: sticky;
    background: #fff;
    bottom: 1rem;
    height: 22vh;
    display: flex;
    justify-content: center;
    width: 99vw;
    box-shadow: 0px -10px 20px 0px #0000002e;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-left: -19px;
  }
  .export-footer-btn {
    top: 22px;
    border-radius: 5px;
    padding: 12px 20px;
    height: 50px;
    width: 38vw;
    font-size: 1rem;
    font-weight: 500;
  }
}

@media (max-width: 430px) {
  .export-selection-container {
    width: 85vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/export-excel-modal/ExportExcel.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,wCAAwC;IACxC,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".selected-columns-export-modal {\n  width: 50vw !important;\n  height: 90vh !important;\n  overflow-y: auto;\n}\n.export-modal-title {\n  font-size: 21px;\n}\n.export-container {\n  overflow-y: auto;\n  border: 1px solid #d3d3d3;\n  height: 528px;\n  border-radius: 10px;\n  opacity: 1;\n  top: 167px;\n  left: 30px;\n  border-width: 1px;\n  padding: 17px 15px;\n  scrollbar-width: thin;\n}\n\n.export-container::-webkit-scrollbar {\n  height: 12px;\n}\n\n.available-column .ant-checkbox-group-item {\n  padding-top: 20px;\n  width: 100%;\n}\n.export-help-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  color: #717171;\n  margin-top: 14px;\n}\n.search-column {\n  background: #f0f0f0 !important;\n  height: 3vh !important;\n  margin-bottom: 1.2rem;\n  border: 1px solid #d9d9d9 !important;\n}\n.set-margin {\n  margin-right: 12px;\n}\n.col-header {\n  padding: 5px 0;\n  font-weight: bold;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.col-label {\n  padding: 5px 0;\n  display: flex;\n  align-items: center;\n}\n.align-right {\n  margin-left: auto;\n}\n.footer-buttons {\n  margin-top: 33px;\n}\n\n.export-footer-btn {\n  height: 35px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n.export-cancel-btn {\n  background: #e0e0e0 !important;\n  color: #0a0f0d !important;\n  opacity: 1;\n  gap: 8px;\n}\n\n.export-btn {\n  background: #d2042d !important;\n  color: #fff !important;\n  cursor: pointer;\n}\n\n.export-spin {\n  height: 50vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .export-selection-container {\n    margin-left: 19px;\n  }\n  .export-selection-container {\n    margin-left: 19px;\n    overflow: auto;\n  }\n  .export-header {\n    height: 70px;\n    font-size: 19px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n  }\n  .export-title {\n    margin-left: 12px;\n  }\n  .reverse-content {\n    display: flex;\n    flex-direction: column-reverse;\n    overflow-y: auto;\n  }\n  .search-column {\n    height: 35px !important;\n  }\n  .available-cols {\n    height: 30vh;\n  }\n  .export-help-text {\n    font-size: 13px;\n    color: #686868;\n    margin-top: 6px;\n    margin-bottom: 16px;\n  }\n  .export-container {\n    background: #fff;\n    width: 88vw;\n  }\n  .selected-cols {\n    height: max-content;\n    margin-bottom: 2rem;\n  }\n  .selected-mobile {\n    margin-top: 24px;\n  }\n\n  .mobile-footer {\n    position: sticky;\n    background: #fff;\n    bottom: 1rem;\n    height: 22vh;\n    display: flex;\n    justify-content: center;\n    width: 99vw;\n    box-shadow: 0px -10px 20px 0px #0000002e;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    margin-left: -19px;\n  }\n  .export-footer-btn {\n    top: 22px;\n    border-radius: 5px;\n    padding: 12px 20px;\n    height: 50px;\n    width: 38vw;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n}\n\n@media (max-width: 430px) {\n  .export-selection-container {\n    width: 85vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
